import { IconButton, InputAdornment, TextField } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { PropsWithChildren, useState, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";

export type FormPasswordProps = {
    rules?: any;
} & FormFieldPropsBase;

export default function FormPassword({
    name,
    id,
    testId,
    label,
    ariaLabel,
    sx,
    readOnly,
    helperText,
    rules,
    disabled
}: PropsWithChildren<FormPasswordProps>): JSX.Element {
    const { control } = useFormContext();
    const [showPassword, setShowPassword] = useState<boolean>();

    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { ref, name, value, onChange, onBlur },
                    fieldState: { invalid, isTouched, isDirty, error },
                    formState
                }: {
                    field: any;
                    fieldState: any;
                    formState: any;
                }) => (
                    <TextField
                        variant="filled"
                        id={id}
                        data-testid={testId}
                        aria-label={ariaLabel ?? undefined}
                        sx={{
                            marginTop: 0,
                            ...sx
                        }}
                        label={label ?? undefined}
                        error={invalid}
                        helperText={invalid ? error.message : helperText}
                        type={showPassword ? 'text' : 'password'}
                        onBlur={onBlur}
                        onChange={onChange}
                        inputRef={ref}
                        value={value}
                        disabled={disabled}
                        slotProps={{
                            input: {
                                readOnly: readOnly,
                                endAdornment:
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={() => {
                                                setShowPassword(password => !password);
                                            }}
                                        >
                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                            },

                            inputLabel: {
                                shrink: true,
                            }
                        }} />
                )
            }
        />
    );
}